import React from 'react';
import { IPhotoModel } from '@common/models';

export class PhotoUtils {
  static getImageSize = (
    width?: number | string,
    height?: number | string,
    placeHolderImage?: string,
    photo?: IPhotoModel,
  ): React.CSSProperties => {
    if (placeHolderImage && !photo)
      return {
        width: 125,
        height: 125,
      };
    else {
      return {
        minWidth: width,
        minHeight: height,
      };
    }
  };
}
